import NotFoundContainer from './not-found-container';

export default NotFoundContainer;
